"use strict";

import React from 'react';
import Card from "./Card";
import {useHistory} from "react-router-dom";

const AccountSettingSecurityCard = ({email=''}) => {
    const history = useHistory();

    function handleEditClick(e){
        e.preventDefault();
        history.push('/echeck/accounts/settings/credentials');
    }

    return (
        <Card title="Sign in and security" onClick={handleEditClick} actionTitle="Edit Security Settings">
            {!!email && <p className="echeck__card__text">{email}</p> }
            <p className="echeck__card__text">Password *******</p>
        </Card>
    );
};

export default AccountSettingSecurityCard;
